import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const CryptoNewsPageStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      height: "400px",
      maxWidth: "400px",
      boxShadow: "3px 3px 10px 0 rgba(0,0,0,0.10)",
      borderRadius: "12px",
      position: "relative",
    },
    titleLeft: {
      color: "#000",
      fontSize: "14px",
      textAlign: "left",
    },
    titleRight: {
      color: "#000",
      fontSize: "14px",
      textAlign: "right",
    },
    textContent: {
      fontWeight: theme.typography.fontWeightMedium,
      textAlign: "left",
      color: "#252525",
      fontSize: "22px",
    },
    readMore: {
      textAlign: "right",
      position: "absolute",
      color: "#252525",
      fontSize: "16px",
      bottom: 0,
      right: 0,
      padding: "20px",
    },
  }),
);
